import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RightsEnum } from 'src/app/enums/rights.enum';
import { ScreensEnum } from 'src/app/enums/screens.enum';
import { IAuth } from 'src/app/models/auth.model';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';

/**
 * This class represents the navigation bar component.
 */
@Component({
    selector: 'dv_navbar',
    templateUrl: 'navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {

    Rights = RightsEnum;
    Screens = ScreensEnum;
    userInfo:IAuth;
    userName:string;

    hasDashboardPerms:boolean;
    hasAlgorithmPerms:boolean;
    hasAlgorithmEnableDisablePerms:boolean;
    hasNotificationRulesPerms:boolean;
    hasNotificationTemplatePerms:boolean;
    hasTemplateLocalePerms:boolean;
    hasRolePerms:boolean;
    hasUserPerms:boolean;
    hasScreenPerms:boolean;
    hasScreenRightGroupPerms:boolean;
    hasRoleToScreenPerms:boolean;
    hasProductFamilyPerms:boolean;
    hasProductLinePerms:boolean;
    hasMasterDataPerms:boolean;
    hasServiceContractPerms:boolean;
    hasServiceContractOverridesPerms:boolean;
    hasExclusionsPerms:boolean;

    isMaintainAuthed:boolean
    isAlgorithmAuthed:boolean
    isNotificationAuthed:boolean
    isAccessControlAuthed:boolean
    isSystemAuthed:boolean

    constructor(public _auth: PermissionsService, public _userAuth: UserPermissionsService, private _storage: LocalStorageService){}
    ngOnInit(): void {

        setTimeout(() => {
            this.userInfo = this._storage.get('user-info');
            this.userName = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
            this.isMaintainAuthed = this.maintainIsAuthed();
            this.isAlgorithmAuthed = this.algorithmIsAuthed();
            this.isNotificationAuthed = this.notificationIsAuthed();
            this.isAccessControlAuthed = this.accessControlIsAuthed();
            this.isSystemAuthed = this.systemIsAuthed();
            this.hasDashboardPerms = this._auth.hasPermission(ScreensEnum.Dashboard, RightsEnum.View)
            this.hasAlgorithmPerms = this._auth.hasPermission(ScreensEnum.Algorithm, RightsEnum.View)
            this.hasAlgorithmEnableDisablePerms = this._auth.hasPermission(ScreensEnum.EnableDisable, RightsEnum.View)
            this.hasNotificationRulesPerms = this._auth.hasPermission(ScreensEnum.NotificationRules, RightsEnum.View)
            this.hasNotificationTemplatePerms = this._auth.hasPermission(ScreensEnum.NotificationTemplate, RightsEnum.View)
            this.hasTemplateLocalePerms = this._auth.hasPermission(ScreensEnum.TemplateLocale, RightsEnum.View)
            this.hasRolePerms = this._auth.hasPermission(ScreensEnum.Role, RightsEnum.View)
            this.hasUserPerms = this._auth.hasPermission(ScreensEnum.User, RightsEnum.View)
            this.hasScreenPerms = this._auth.hasPermission(ScreensEnum.Screen, RightsEnum.View)
            this.hasScreenRightGroupPerms = this._auth.hasPermission(ScreensEnum.ScreenRightGroup, RightsEnum.View)
            this.hasRoleToScreenPerms = this._auth.hasPermission(ScreensEnum.RoleToScreen, RightsEnum.View)
            this.hasProductFamilyPerms = this._auth.hasPermission(ScreensEnum.ProductFamily, RightsEnum.View)
            this.hasProductLinePerms = this._auth.hasPermission(ScreensEnum.ProductLine, RightsEnum.View)
            this.hasMasterDataPerms = this._auth.hasPermission(ScreensEnum.MasterData, RightsEnum.View)
            this.hasServiceContractPerms = this._auth.hasPermission(ScreensEnum.ServiceContract, RightsEnum.View)
            this.hasServiceContractOverridesPerms = this._auth.hasPermission(ScreensEnum.ServiceContractOverride, RightsEnum.View)
            this.hasExclusionsPerms = this._auth.hasPermission(ScreensEnum.Exclusions, RightsEnum.View)
        }, 500)
    }

    toggle() {
        let navbarLinks = document.getElementsByClassName('navbar-links')[0];
        navbarLinks.classList.toggle('active')
    }

    maintainIsAuthed(): boolean {
        return this._auth.hasAtLeastOnePermission([
            ScreensEnum.Role,
            ScreensEnum.User,
            ScreensEnum.Screen,
            ScreensEnum.ScreenRightGroup,
            ScreensEnum.RoleToScreen,
            ScreensEnum.Algorithm,
            ScreensEnum.ProductFamily,
            ScreensEnum.ProductLine,
            ScreensEnum.MasterData,
            ScreensEnum.ServiceContract,
            ScreensEnum.Exclusions,
            ScreensEnum.NotificationTemplate,
            ScreensEnum.NotificationRules], RightsEnum.View);
    }

    systemIsAuthed(): boolean {
        return this._auth.hasAtLeastOnePermission([
            ScreensEnum.MasterData,
            ScreensEnum.ServiceContract,
            ScreensEnum.Exclusions,
            ScreensEnum.ProductFamily,
            ScreensEnum.ProductLine,], RightsEnum.View);
    }

    algorithmIsAuthed(): boolean {
        return this._auth.hasAtLeastOnePermission([
            ScreensEnum.Algorithm,
            ScreensEnum.EnableDisable], RightsEnum.View);
    }

    accessControlIsAuthed(): boolean {
        return this._auth.hasAtLeastOnePermission([
            ScreensEnum.Role,
            ScreensEnum.User,
            ScreensEnum.Screen,
            ScreensEnum.ScreenRightGroup,
            ScreensEnum.RoleToScreen], RightsEnum.View);
    }

    notificationIsAuthed(): boolean {
        return this._auth.hasAtLeastOnePermission([
            ScreensEnum.NotificationRules,
            ScreensEnum.NotificationTemplate,
            ScreensEnum.TemplateLocale], RightsEnum.View);
    }

}
